<template>
  <v-row no-gutters class="fill-height">
    <crud-factory
      :serviceName="serviceName"
      :crudDialog="crudDialog"
      :editCustomView="editCustomView"
    />
  </v-row>
</template>

<script>
import ProgressioEditForm from "./edit/ProgressioEditForm"

export default {
  components: {
    crudFactory: () => import("./CrudFactory"),
  },
  data() {
    return {
      serviceName: "progressions",
      crudDialog: {
        large: false,
        createTitle: "Nova progressió",
        modelKeyTitle: "nom",
      },
      editCustomView: ProgressioEditForm,
    }
  },
}
</script>

<style lang="scss" scoped />
